import React, { useState, useEffect, useRef } from "react";

const PhoneNumberMask = (props) => {
  const inputCard = useRef();

  const startingTabIndex = props?.startTabIndex ?? 0;

  const handleChange = () => {
    const cardValue = inputCard.current.value
      .replace(/\D/g, "")
      .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
   
    inputCard.current.value = !cardValue[2]
      ? cardValue[1]
      : `(${cardValue[1]}) ${cardValue[2]}${`${
          cardValue[3] ? `-${cardValue[3]}` : ""
        }`}${`${cardValue[4] ? `-${cardValue[4]}` : ""}`}`;
    const numbers = inputCard.current.value.replace(/(\D)/g, "");
    props.setValue("phoneNo",numbers);
    // props.setError("phoneNo",{type: "error"})
    props.setClearError('phoneNo');
  };

  useEffect(() => {    
    handleChange()
    props?.setPhoneRef?.(inputCard);
    // props.setError('phoneNo',{type:'error',message:'Cell no is required'})
  }, []);

  return (
    <>
      {/* <input
      className="form-control bg-light fs-6"
      
      id="phoneNumber"
        placeholder="Phone No"
        type="text"
        // ref={inputCard}
        onChange={handleChange}        
      /> */}

      {/* <input
        tabIndex={startingTabIndex + 1}
        autoComplete="off"
        type="tel"
        ref={inputCard}
        onChange={handleChange}
        className="phoneNumberInputSignupPage"
        id="phoneNumber"
        name="no-autofill-phone"
        placeholder='(555) 000-0000'
        onFocus={(e) => e.target.removeAttribute('readOnly')}
        readOnly
         inputMode="numeric"

      /> */}
      <input
        tabIndex={startingTabIndex + 1}
        type="tel"
        ref={inputCard}
        onChange={handleChange}
        className="phoneNumberInputSignupPage"
        id="something-random"
        placeholder="(555) 000-0000"
      />
    </>
  );
};

export default PhoneNumberMask;